export const FLOOR_PLAN_3D_FURNISHING_DEFAULT = 'furnished';

export const FLOOR_PLAN_3D_FURNISHING_OPTIONS = [
  { value: 'furnished', label: 'Furnished' },
  { value: 'unfurnished', label: 'Unfurnished' },
];
